/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
    isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
    title: "Prathamesh's Portfolio",
    description: "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
    og: {
        title: "Prathamesh Sawant Portfolio",
        type: "website",
        url: "https://prathameshsawant.com",
    },
};

//Home Page
const greeting = {
    title: "Prathamesh Sawant",
    logo_name: "Prathamesh",
    nickname: "Pratham",
    subTitle: "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
    resumeLink: "https://drive.google.com/file/d/1VBCfcS9-zw4wW2t1LlZwh3sicwnoKAQw/view?usp=drivesdk",
    portfolio_repository: "https://github.com/prathamesh78/Linux",
    githubProfile: "https://github.com/prathamesh78",
};

const socialMediaLinks = [
    /* Your Social Media Link */
    // github: "https://github.com/ashutosh1919",
    // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
    // gmail: "ashutoshhathidara98@gmail.com",
    // gitlab: "https://gitlab.com/ashutoshhathidara98",
    // facebook: "https://www.facebook.com/laymanbrother.19/",
    // twitter: "https://twitter.com/ashutosh_1919",
    // instagram: "https://www.instagram.com/layman_brother/"

    {
        name: "Github",
        link: "https://github.com/prathamesh78",
        fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
        backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
    },
    {
        name: "LinkedIn",
        link: "https://linkedin.com/in/prathamesh-sawant-54b78121b",
        fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
        backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
    },
    /*{
          name: "YouTube",
          link: "https://youtube.com/c/DevSense19",
          fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
          backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
      },*/
    {
        name: "Gmail",
        link: "mailto:prathameshrs78@gmail.com",
        fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
        backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
    },
    /*{
          name: "X-Twitter",
          link: "https://twitter.com/ashutosh_1919",
          fontAwesomeIcon: "fa-x-twitter", // Reference https://fontawesome.com/icons/x-twitter?f=brands&s=solid
          backgroundColor: "#000000", // Reference https://simpleicons.org/?q=x
      },*/
    /*{
          name: "Facebook",
          link: "https://www.facebook.com/laymanbrother.19/",
          fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
          backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
      },*/
    /* {
           name: "X-Twitter",
           link: "https://www.instagram.com/layman_brother/",
           fontAwesomeIcon: "fa-x-twitter", // Reference https://fontawesome.com/icons/instagram?style=brands
           backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
       },*/
];

const skills = {
    data: [{
            title: "Cloud Infra-Architecture",
            fileName: "CloudInfraImg",
            skills: [
                "⚡ Extensive experience working with multiple cloud platforms including AWS, Azure, and GCP",
                "⚡ Hosting and maintaining websites on virtual machine instances",
                "⚡ Orchestrating containerized workloads using Docker and container orchestration platforms like Kubernetes for improving scalability, portability, and resource utilization",
                "⚡ Implementing CI/CD pipelines and automating infrastructure provisioning for efficient software delivery and deployment",
            ],
            softwareSkills: [{
                    skillName: "AWS",
                    fontAwesomeClassname: "simple-icons:amazonaws",
                    style: {
                        color: "#FF9900",
                    },
                },
                {
                    skillName: "GCP",
                    fontAwesomeClassname: "simple-icons:googlecloud",
                    style: {
                        color: "#4285F4",
                    },
                },

                {
                    skillName: "Linux",
                    fontAwesomeClassname: "skill-icons:linux-light",
                    style: {
                        color: "#47A248",
                    },
                },
                {
                    skillName: "Docker",
                    fontAwesomeClassname: "simple-icons:docker",
                    style: {
                        color: "#1488C6",
                    },
                },
                {
                    skillName: "Kubernetes",
                    fontAwesomeClassname: "simple-icons:kubernetes",
                    style: {
                        color: "#326CE5",
                    },
                },
                {
                    skillName: "Jenkins",
                    fontAwesomeClassname: "skill-icons:jenkins-light",
                    style: {
                        color: "#0089D6",
                    },
                },
                {
                    skillName: "Ansible",
                    fontAwesomeClassname: "devicon:ansible",
                    style: {
                        color: "#FFCA28",
                    },
                },
                {
                    skillName: "Terraform",
                    fontAwesomeClassname: "logos:terraform-icon",
                    style: {
                        color: "#336791",
                    },
                },
                {
                    skillName: "Prometheus",
                    fontAwesomeClassname: "devicon:prometheus",
                    style: {
                        color: "#336791",
                    },
                },
                {
                    skillName: "Grafana",
                    fontAwesomeClassname: "skill-icons:grafana-dark",
                    style: {
                        color: "#336791",
                    },
                },
            ],
        },
        {
            title: "Data Science & AI",
            fileName: "DataScienceImg",
            skills: [
                "⚡ Developing and deploying machine learning models for predictive analytics and data-driven insights",
                "⚡ Utilizing computer vision techniques for image recognition and object detection tasks",
                "⚡ Integrating machine learning models into production systems for real-time decision-making",
                "⚡ Contributing to model evaluation and validation processes, ensuring accuracy and reliability.",
            ],
            softwareSkills: [{
                    skillName: "Tensorflow",
                    fontAwesomeClassname: "logos-tensorflow",
                    style: {
                        backgroundColor: "transparent",
                    },
                },
                {
                    skillName: "Keras",
                    fontAwesomeClassname: "simple-icons:keras",
                    style: {
                        backgroundColor: "white",
                        color: "#D00000",
                    },
                },
                {
                    skillName: "OpenCV",
                    fontAwesomeClassname: "skill-icons:opencv-dark",
                    style: {
                        backgroundColor: "transparent",
                    },
                },
                {
                    skillName: "Python",
                    fontAwesomeClassname: "ion-logo-python",
                    style: {
                        backgroundColor: "transparent",
                        color: "#3776AB",
                    },
                },
                {
                    skillName: "Deeplearning",
                    imageSrc: "deeplearning_ai_logo.png",
                },
                {
                    skillName: "Numpy",
                    fontAwesomeClassname: "devicon-plain:numpy",
                    style: {
                        backgroundColor: "white",
                        color: "#3776AB",
                    },
                },
            ],
        },
        {
            title: "Web Development",
            fileName: "FullStackImg",
            skills: [
                "⚡ Proficient in front-end development technologies such as HTML, CSS, and JavaScript",
                "⚡ Experience with modern front-end frameworks/libraries like React and Angular",
                "⚡ Familiarity with back-end development using languages/frameworks such as Node.js and Python/Flask",
                "⚡ Developing responsive and user-friendly web interfaces for optimal user experience across devices",
            ],
            softwareSkills: [{
                    skillName: "HTML5",
                    fontAwesomeClassname: "simple-icons:html5",
                    style: {
                        color: "#E34F26",
                    },
                },
                {
                    skillName: "CSS3",
                    fontAwesomeClassname: "fa-css3",
                    style: {
                        color: "#1572B6",
                    },
                },
                {
                    skillName: "JavaScript",
                    fontAwesomeClassname: "simple-icons:javascript",
                    style: {
                        backgroundColor: "#000000",
                        color: "#F7DF1E",
                    },
                },
                {
                    skillName: "ReactJS",
                    fontAwesomeClassname: "simple-icons:react",
                    style: {
                        color: "#61DAFB",
                    },
                },
                {
                    skillName: "NodeJS",
                    fontAwesomeClassname: "logos:nodejs-icon",
                    style: {
                        backgroundColor: "white",
                        color: "#339933",
                    },
                },
                {
                    skillName: "AngularJS",
                    fontAwesomeClassname: "skill-icons:angular-light",
                    style: {
                        color: "#2C8EBB",
                    },
                },
                {
                    skillName: "NPM",
                    fontAwesomeClassname: "simple-icons:npm",
                    style: {
                        color: "#CB3837",
                    },
                },
                {
                    skillName: "Flask",
                    fontAwesomeClassname: "simple-icons:flask",
                    style: {
                        color: "#CC6698",
                    },
                },
            ],
        },
    ],
};

// Education Page
const competitiveSites = {
    competitiveSites: [
        /*{
                siteName: "LeetCode",
                iconifyClassname: "simple-icons:leetcode",
                style: {
                    color: "#F79F1B",
                },
                profileLink: "https://leetcode.com/layman_brother/",
            },
            {
                siteName: "HackerRank",
                iconifyClassname: "simple-icons:hackerrank",
                style: {
                    color: "#2EC866",
                },
                profileLink: "https://www.hackerrank.com/layman_brother",
            },
            {
                siteName: "Codechef",
                iconifyClassname: "simple-icons:codechef",
                style: {
                    color: "#5B4638",
                },
                profileLink: "https://www.codechef.com/users/ashutosh_1919",
            },
            {
                siteName: "Codeforces",
                iconifyClassname: "simple-icons:codeforces",
                style: {
                    color: "#1F8ACB",
                },
                profileLink: "http://codeforces.com/profile/layman_brother",
            },
            {
                siteName: "Hackerearth",
                iconifyClassname: "simple-icons:hackerearth",
                style: {
                    color: "#323754",
                },
                profileLink: "https://www.hackerearth.com/@ashutosh391",
            },
            {
                siteName: "Kaggle",
                iconifyClassname: "simple-icons:kaggle",
                style: {
                    color: "#20BEFF",
                },
                profileLink: "https://www.kaggle.com/laymanbrother",
            },*/
    ],
};

const degrees = {
    degrees: [{
            title: "MIT Academy of Engineering, Pune",
            subtitle: "B.Tech. in Electronics and Telecommunication",
            logo_path: "mitlogo.png",
            alt_name: "MITAOE",
            duration: "2019 - 2023",
            descriptions: [
                "⚡ I have studied basic software engineering subjects like DS, Algorithms, DBMS, OS, CA, AI etc.",
                "⚡ Apart from this, I have done courses on Deep Learning, Data Science, Cloud Computing and Full Stack Development.",
                "⚡ I was selected for Merit cum Means Scholarship which is given to top 10% of students in college. I have received award from respected director for consistently best performance in academics.",
            ],
            website_link: "https://mitaoe.ac.in/",
        },
        /*  {
                    title: "Indiana University Bloomington",
                    subtitle: "M.S. in Computer Science",
                    logo_path: "iu_logo.png",
                    alt_name: "Indiana University Bloomington",
                    duration: "2021 - 2023",
                    descriptions: [
                        "⚡ I have taken varity of courses related to Artificial Intelligence which correspond to Explainable AI, Graph Machine Learning, Computer Vision etc.",
                        "⚡ Apart from this, I have also done research assistantship. As part of it, I have worked on creating new algorithms in Graph ML and Network Science.",
                        "⚡ During my time at university, I was also associated with multimedia department. As part of it, I have worked on some documentry films and interviews.",
                    ],
                    website_link: "https://www.indiana.edu/",
                },*/
    ],
};

const certifications = {
    certifications: [{
            title: "AWS Academy Cloud Foundations",
            subtitle: "- AWS Academy Graduate",
            logo_path: "aws-logo.png",
            certificate_link: "https://www.credly.com/go/Ejt2LR4B",
            alt_name: "AWS",
            color_code: "#8C151599",
        },
        {
            title: "Cloud Engineering on GCP",
            subtitle: "- GCP Training",
            logo_path: "google_logo.png",
            certificate_link: "https://drive.google.com/file/d/1TVXhT2LqQ8t1eTqxVGUqRNAbyp48c5xO/view?usp=drivesdk",
            alt_name: "Google",
            color_code: "#0C9D5899",
        },
        {
            title: "Introduction to Industry 4.0 and Industrial Internet of Things",
            subtitle: "- NPTEL",
            logo_path: "nptel_logo.png",
            certificate_link: "https://drive.google.com/file/d/1TmCcAcHG-hX2KZELld11tYXvlN8-vHPv/view?usp=drivesdk",
            alt_name: "NPTEL",
            color_code: "#FFBB0099",
        },
        {
            title: "Fullstack Web Development",
            subtitle: "- Codekul pvt. Limited ",
            logo_path: "coursera_logo.png",
            certificate_link: "https://drive.google.com/file/d/1TVy1_VS6rB3PPROnpfNZ_cEZXeeazPXe/view?usp=drivesdk",
            alt_name: "Coursera",
            color_code: "#2A73CC",
        },
        {
            title: "Data Science and Machine Learning on GCP",
            subtitle: "- Qwiklabs",
            logo_path: "gcp_logo.png",
            certificate_link: "https://drive.google.com/file/d/1TVXhT2LqQ8t1eTqxVGUqRNAbyp48c5xO/view?usp=drivesdk",
            alt_name: "GCP",
            color_code: "#4285F499",
        },
        {
            title: "MATLAB Onramp",
            subtitle: "- MathWorks",
            logo_path: "matlab.png",
            certificate_link: "https://drive.google.com/file/d/1TmCcAcHG-hX2KZELld11tYXvlN8-vHPv/view?usp=drivesdk",
            alt_name: "MATLAB",
            color_code: "#FFBB0099",
        },
        {
            title: "VLSI SoC Design Using Verilog HDL",
            subtitle: "- Maven Silicon",
            logo_path: "mvns.png",
            certificate_link: "https://drive.google.com/file/d/1TZB3TL8LJkObuTGacFGGyNEIfhzAUf3M/view?usp=drivesdk",
            alt_name: "Maven-Silicon",
            color_code: "#0C9D5899",
        },
        {
            title: "Google Kubernetes Engine",
            subtitle: "- Qwiklabs",
            logo_path: "gcp_logo.png",
            certificate_link: "https://www.cloudskillsboost.google/public_profiles/df5d54f2-5aa8-4c8c-b6b7-1d4492f52b4f/badges/3043155",
            alt_name: "GCP",
            color_code: "#4285F499",
        },
        {
            title: "Google Cloud Infrastructure",
            subtitle: "- Qwiklabs",
            logo_path: "gcp_logo.png",
            certificate_link: "https://www.cloudskillsboost.google/public_profiles/df5d54f2-5aa8-4c8c-b6b7-1d4492f52b4f/badges/3059966",
            alt_name: "GCP",
            color_code: "#4285F499",
        },
    ],
};

// Experience Page
const experience = {
    title: "Experience",
    subtitle: "Work, Internship and Volunteership",
    description: "I have worked with small scale companies as AWS DevOps Intern. I have also worked with some well established companies as Web and ML Developer. I love organising events and that is why I am also involved with many opensource communities as a representative.",
    header_image_path: "experience.svg",
    sections: [{
            title: "Work",
            work: true,
            experiences: [{
                title: "AWS DevOps Engineer",
                company: "StarAgile Trainings",
                company_url: "https://staragile.com/in",
                logo_path: "staragile-logo.png",
                duration: "Dec 2023 - Apr 2024",
                location: "Bengaluru, Karnataka",
                description: "Assisted in migrating on-premises infrastructure to AWS, gaining hands-on experience with EC2, S3, and RDS. Contributed to Infrastructure as Code using CloudFormation, setup CI/CD pipelines with CodePipeline and GitHub Actions. Learned Docker containerization and orchestration with ECS. Supported monitoring via CloudWatch, engaged in security compliance, and actively collaborated in troubleshooting. Demonstrated proactive learning, suggesting process improvements, and fostering teamwork.",
                color: "#fc1f20",
            }, ],
        },
        {
            title: "Internships",
            experiences: [{
                title: "Web Devlopment Intern",
                company: "CodeKul pvt. Limited",
                company_url: "http://www.codekul.com/",
                logo_path: "codekul-logo.png",
                duration: "June 2021 - Aug 2021",
                location: "Pune, Maharashtra",
                description: "Contributed to front-end and back-end development projects, gaining proficiency in HTML, CSS, JavaScript, and Node.js. Assisted in building responsive web applications and APIs, collaborating with team members to meet project requirements. Learned version control with Git and participated in Agile development methodologies. Conducted code reviews and resolved bugs to ensure product quality. Demonstrated adaptability and eagerness to learn new technologies while contributing to a positive team environment.",
                color: "#000000",
            }, ],
        },
        {
            title: "Volunteerships",
            experiences: [{
                    title: "Content Lead",
                    company: "Google Developer Student's Club, MITAOE",
                    company_url: "https://developers.google.com/community/gdsc",
                    logo_path: "google_logo.png",
                    duration: "June 2021 - Aug 2022",
                    location: "Pune, Maharashtra",
                    description: "We have well established developer club in college which is directly associated with Google Developers. We have developed many interdisciplinary projects under the membership of this club. We have organised workshops and activities on Google Cloud Platforms",
                    color: "#4285F4",
                },
                {
                    title: "Member, MITAOE Cultural Team",
                    company: "MIT Academy of Engineering, Pune",
                    company_url: "https://mitaoe.ac.in/",
                    logo_path: "mitlogo.png",
                    duration: "Aug 2022 - May 2023",
                    location: "Pune, Maharashtra",
                    description: "Organized various cultural events in the collage and was awarded as a best supporting Cultural Volunteer.",
                    color: "#D83B01",
                },
                {
                    title: "Kabbadi Player",
                    company: "MIT Academy Of Engineering, Pune",
                    company_url: "https://mitaoe.ac.in/",
                    logo_path: "kabbadi.png",
                    duration: "Aug 2019 - May 2023",
                    location: "Pune, Maharashtra",
                    description: "Represented as Vice-Captain for College Kabbadi Team at University Level and won Intra college Championship.",
                    color: "#000000",
                },
            ],
        },
    ],
};

// Projects Page
const projectsHeader = {
    title: "Projects",
    description: "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects and deploy them to web applications using cloud infrastructure.",
    avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
    title: "Publications",
    description: "I have worked on and published a few research papers and publications of my own.",
    avatar_image_path: "projects_image.svg",
};

const publications = {
    data: [{
            id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzQ=",
            name: "Artificial Intelligence and Machine Learning Paper",
            createdAt: "2024-01-06T16:26:54Z",
            description: "Paper Written on Real-time AI-Based Face Mask Detection published in 5th International Conference on Advances in Distributed Computing and Machine Learning (ICADCML)-2024 ",
            url: "https://drive.google.com/file/d/1U2hbcSM3qCWohNOMbBgJLvBk91jAP9J4/view?usp=drivesdk",
        },
        /*{
                id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzi=",
                name: "Artificial Intelligence Paper",
                createdAt: "2020-03-06T16:26:54Z",
                description: "Paper Written on Artificial Intelligence published in xyz ",
                url: "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
            },*/
    ],
};

// Contact Page
const contactPageData = {
    contactSection: {
        title: "Contact Me",
        profile_image_path: "prathamesh.png",
        description: "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with ML, AI, Cloud and Opensource Development.",
    },
    blogSection: {
        title: "Blogs",
        subtitle: "For individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to change the core of their character.",
        link: "https://https://github.com/prathamesh78",
        avatar_image_path: "blogs_image.svg",
    },
    addressSection: {
        title: "Address",
        subtitle: "1352/1 C Ward, Kolhapur 416010",
        locality: "Rankala",
        country: "IN",
        region: "Maharashtra",
        postalCode: "416010",
        streetAddress: "C ward",
        avatar_image_path: "address_image.svg",
        location_map_link: "https://maps.app.goo.gl/CeP7yPtJGkjDp8jNA",
    },
    phoneSection: {
        title: "",
        subtitle: "",
    },
};

export {
    settings,
    seo,
    greeting,
    socialMediaLinks,
    skills,
    competitiveSites,
    degrees,
    certifications,
    experience,
    projectsHeader,
    publicationsHeader,
    publications,
    contactPageData,
};